import React, { useEffect, useState } from "react";
import {
    Container,
    Card,
    CardBody,
    Alert,
    Button,
    Label,
    Input,
    Form,
    FormFeedback,
    Row,
} from "reactstrap";
import Select from "react-select";
import { useNavigate, useSearchParams } from "react-router-dom";
import UserService from "Api/Services/UserService";
import Spinners from "components/Common/Spinner";
import PageTitle from "../../../components/Common/PageTitle";

const UserAdd = () => {
    const [searchParams] = useSearchParams();
    const defaultAccountType = searchParams.get("type") === "shared-login";

    const [status, setStatus] = useState(true);
    const [previewImage, setPreviewImage] = useState(null);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    const [name, setName] = useState();
    const [phoneNumber, setPhoneNumber] = useState();
    const [password, setPassword] = useState("");
    const [passwordLength, setPasswordLength] = useState(12);
    const [passwordMSG, setPasswordMSG] = useState();
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [getSpecialty, setSpecialty] = useState('');
    const [getQualification, setQualification] = useState('');
    const [getPracticename, setPracticename] = useState('');
    const [isGroupLogin, setIsGroupLogin] = useState(defaultAccountType);
    const [doctorOptions, setDoctorOptions] = useState([]);
    const [selectedDoctorUserIds, setSelectedDoctorUserIds] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [errorimage, setErrorimage] = useState(false);
    const [getFaxNumber, setFaxNumber] = useState('');

    const accountTitle = isGroupLogin ? "Shared Login" : "Doctor";
    const accountDescription = isGroupLogin
        ? "Create one office login and choose which doctors that login can access."
        : "Create an individual provider account.";

    document.title = `Add ${accountTitle} | Infuse One`;

    useEffect(() => {
        if (isGroupLogin) {
            loadDoctorOptions();
        }
    }, [isGroupLogin]);

    const loadDoctorOptions = async () => {
        try {
            const response = await UserService.GetDoctorGroupMemberOptions().json();

            if (response.status) {
                const doctorAccounts = response.data?.doctor_accounts || [];
                setDoctorOptions(doctorAccounts.map(account => ({
                    value: account.id,
                    label: account.display_name || account.name,
                })));
            }
        } catch (loadError) {
            console.error(loadError);
        }
    };
    // Toggle user status
    const handleStatusChange = () => setStatus(!status);

    // Image preview handler
    // const handleImageChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setPreviewImage(reader.result);
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };

    const handleImageChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const fileType = file.type;
            const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

            if (validImageTypes.includes(fileType)) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreviewImage(reader.result);
                };
                reader.readAsDataURL(file);
            } else {
                setErrorimage('Please upload a valid image.');
                return;
                // alert('Please upload a valid image file.');
            }
        }
    };

    // Form submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            username: e.target.username.value,
            name: e.target.name.value,
            practicename: isGroupLogin ? e.target.name.value : e.target.practicename.value,
            email: e.target.email.value,
            phone_number: e.target.phone_number.value,
            password: e.target.password.value,
            profile_image: previewImage,
            specialty: e.target.specialty ? e.target.specialty.value : '',
            qualification: getQualification,
            is_active: status ? '1' : '0',
	    faxnumber: getFaxNumber,
            is_group_login: isGroupLogin ? 1 : 0,
        };

        if (isGroupLogin) {
            formData.create_doctor_group_name = e.target.name.value;
            formData.doctor_user_ids = selectedDoctorUserIds;
        }

        // setLoading(true);
        try {
            const response = await UserService.AddUser(formData).json();

            if (response.status) {
                setSuccess(response.message);
                navigate(`/user-list?view=${isGroupLogin ? 'shared-login' : 'doctor'}`);
                setErrorimage('');
                // setLoading(false);
            } else {
                setError(response.errors);
            }
        } catch (error) {
            console.error(error);
            setError('Something went wrong');
        }
    };

    const handleNameChange = (e) => {
        const regex = /^[A-Za-z\s]*$/;
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setName(newValue);
        }
    };
    const handlePracticenameChange = (e) => {
        const regex = /^[A-Za-z\s]*$/;
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setPracticename(newValue);
        }
    };


    const handlePhoneNumberChange = (e) => {
        const newValue = e.target.value;
        if (/^\d{0,12}$/.test(newValue)) {
            setPhoneNumber(newValue);
        }
    };

    const generatePassword = () => {

        let charset = "";
        let newPassword = "";

        charset += "!@#$%^&*()";
        charset += "0123456789";
        charset += "abcdefghijklmnopqrstuvwxyz";
        charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

        for (let i = 0; i < passwordLength; i++) {
            newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
        }

        setPassword(newPassword);
        setPasswordMSG('');

    };

    const copyToClipboard = () => {
        if (password.trim() === '') {
            setPasswordMSG('');
        } else {
            navigator.clipboard.writeText(password);
            setPasswordMSG('Password copied!');
        }
    };

    const previewPassword = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const handleSpecialtyChange = (e) => {
        const regex = /^[A-Za-z\s]*$/;
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setSpecialty(newValue);
        }
    };

    const handleQualificationChange = (e) => {
        const regex = /^\d{0,10}$/; // Only digits allowed
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setQualification(newValue);
        }
    }; 
  	
    const handleFaxnumberonChange = (e) => {
    	const regex = /^[0-9\s!@#$%^&*()_\-+=\[\]{}|\\;:'",.<>/?`~]*$/;
	const newValue = e.target.value;
	   if(regex.test(newValue)){
		setFaxNumber(newValue);
	   }
    }

	

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="container-fluid">
                        <PageTitle title={`Add ${accountTitle}`} />
                        <Row>
                            {isLoading ? <Spinners setLoading={setLoading} /> :
                                <Card className="commonboxform">
                                    <CardBody className="p-4">
                                        <div className="mb-4">
                                            <h4 className="mb-1">Add {accountTitle}</h4>
                                            <div className="text-muted">{accountDescription}</div>
                                        </div>
                                        {success && (
                                            <Alert color="success" style={{ marginTop: "13px" }}>
                                                {success}
                                            </Alert>
                                        )}
                                        {error.general && (
                                            <Alert color="danger" style={{ marginTop: "13px" }}>
                                                {error.general}
                                            </Alert>
                                        )}

                                        {/* <h4 className="card-title mb-4">Add New User</h4> */}

                                        <Form className="form-horizontal" onSubmit={handleSubmit}>
                                            <div className="mb-4">
                                                <Label className="form-label">Account Type</Label>
                                                <div className="d-flex flex-wrap gap-2">
                                                    <Button
                                                        type="button"
                                                        color={isGroupLogin ? "light" : "secondary"}
                                                        onClick={() => setIsGroupLogin(false)}
                                                    >
                                                        Doctor
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        color={isGroupLogin ? "secondary" : "light"}
                                                        onClick={() => setIsGroupLogin(true)}
                                                    >
                                                        Shared Login
                                                    </Button>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="mb-3">
                                                    <Label className="form-label">Username <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="username"
                                                        name="username"
                                                        placeholder="Enter username"
                                                    />
                                                    {error.username && (
                                                        <FormFeedback type="invalid" style={{ display: 'block' }}>{error.username[0]}</FormFeedback>
                                                    )}
                                                </div>
                                                <div className="mb-3">
                                                    <Label className="form-label">{isGroupLogin ? "Shared Login Display Name" : "Provider Name"} <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="name"
                                                        name="name"
                                                        placeholder={isGroupLogin ? "Enter Shared Login Display Name" : "Enter Provider Name"}
                                                        value={name}
                                                        onChange={handleNameChange}
                                                    />
                                                    {error.name && (
                                                        <FormFeedback type="invalid" style={{ display: 'block' }}>{error.name[0]}</FormFeedback>
                                                    )}
                                                </div>

                                                {!isGroupLogin ? (
                                                    <div className="mb-3">
                                                        <Label className="form-label">Practice Name <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id="practicename"
                                                            name="practicename"
                                                            placeholder="Enter Practice Name"
                                                            value={getPracticename}
                                                            onChange={handlePracticenameChange}
                                                        />
                                                        {error.practicename && (
                                                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.practicename[0]}</FormFeedback>
                                                        )}
                                                    </div>
                                                ) : null}

                                                {isGroupLogin ? (
                                                    <div className="mb-3">
                                                        <Label className="form-label">Doctors this shared login can access</Label>
                                                        <Select
                                                            isMulti
                                                            options={doctorOptions}
                                                            value={doctorOptions.filter(option => selectedDoctorUserIds.includes(option.value))}
                                                            onChange={selected => setSelectedDoctorUserIds(selected ? selected.map(option => option.value) : [])}
                                                            placeholder="Choose doctors"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menu: base => ({ ...base, zIndex: 9999 }),
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                            }}
                                                            closeMenuOnSelect={false}
                                                        />
                                                        <div className="text-muted small mt-2">
                                                            This shared login will automatically create one doctor group for the doctors you choose here.
                                                        </div>
                                                    </div>
                                                ) : null}

                                                <div className="mb-3">
                                                    <Label className="form-label">Office Contact Email <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                                    <Input
                                                        type="email"
                                                        className="form-control"
                                                        id="email"
                                                        name="email"
                                                        placeholder="Enter Office Contact Email"
                                                    />
                                                    {error.email && (
                                                        <FormFeedback type="invalid" style={{ display: 'block' }}>{error.email[0]}</FormFeedback>
                                                    )}
                                                </div>

                                                <div className="mb-3">
                                                    <Label className="form-label">Phone Number <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="phone_number"
                                                        name="phone_number"
                                                        placeholder="Enter phone number"
                                                        onChange={handlePhoneNumberChange}
                                                        value={phoneNumber}
                                                    />
                                                    {error.phone_number && (
                                                        <FormFeedback type="invalid" style={{ display: 'block' }}>{error.phone_number[0]}</FormFeedback>
                                                    )}
                                                </div>
                                                {!isGroupLogin ? (
                                                    <>
                                                        <div className="mb-3">
                                                            <Label className="form-label">Specialty <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                                            <Input
                                                                type="text"
                                                                className="form-control"
                                                                id="specialty"
                                                                name="specialty"
                                                                placeholder="Enter Specialty"
                                                                value={getSpecialty}
                                                                onChange={handleSpecialtyChange}
                                                            />
                                                            {error.specialty && (
                                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.specialty[0]}</FormFeedback>
                                                            )}
                                                        </div>
                                                        <div className="mb-3">
                                                            <Label className="form-label">NPI <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                                            <Input
                                                                type="text"
                                                                className="form-control"
                                                                id="qualification"
                                                                name="qualification"
                                                                placeholder="Enter NPI"
                                                                value={getQualification}
                                                                onChange={handleQualificationChange}
                                                            />
                                                            {error.qualification && (
                                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.qualification[0]}</FormFeedback>
                                                            )}
                                                        </div>
						<div className="mb-3">
				    			    <Label className="form-lable">Fax number<i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
				    			    <input
				    				type="text"
				    				className="form-control"
				    				id="faxnumberid"
				    				name="faxnumber"
				    				placeholder="Enter fax number"
				    				value={getFaxNumber}
				    				onChange={handleFaxnumberonChange}
				    			    />
				    			    {error.faxnumber && (
								    <FormFeedback type="invalid" style={{ display: 'block' }}>{error.faxnumber[0]}</FormFeedback>
							    )}
					            </div>
                                                    </>
                                                ) : null}
				    	
                                                <div className="mb-3">
                                                    <Label className="form-label">Password <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                                    <div className="d-flex gap-3">
                                                        <Input
                                                            type={isPasswordVisible ? 'text' : 'password'}
                                                            className="form-control"
                                                            id="password"
                                                            name="password"
                                                            placeholder="Enter Password"
                                                            value={password}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            invalid={!!error?.password}
                                                        />
                                                        {isPasswordVisible ?
                                                            <Button type="button" color="secondary" onClick={previewPassword} title="Show" >
                                                                <i className='bx bx-show'></i>
                                                            </Button>
                                                            :
                                                            <Button type="button" color="secondary" onClick={previewPassword} title="Hide" >
                                                                <i className='bx bx-hide'></i>
                                                            </Button>
                                                        }
                                                        <Button type="button" color="secondary" onClick={generatePassword} title="Generate">
                                                            <i className='bx bx-revision'></i>
                                                        </Button>
                                                        <Button type="button" color="info" onClick={copyToClipboard} title="Copy">
                                                            <i className='bx bx-copy-alt'></i>
                                                        </Button>
                                                    </div>
                                                    {passwordMSG && (
                                                        <FormFeedback type="valid" className="text-success" style={{ display: 'block' }}>{passwordMSG}</FormFeedback>
                                                    )}
                                                    {error.password && (
                                                        <FormFeedback type="invalid" style={{ display: 'block' }}>{error.password[0]}</FormFeedback>
                                                    )}
                                                </div>

                                                {!isGroupLogin ? (
                                                    <div className="mb-3">
                                                        <Label className="form-label">Profile Image <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                                        {previewImage && (
                                                            <div className="mb-3 text-left">
                                                                <img
                                                                    src={previewImage}
                                                                    alt="Profile Preview"
                                                                    className="img-fluid"
                                                                    style={{ width: '100px', height: '60px', objectFit: 'cover' }}
                                                                />
                                                            </div>
                                                        )}
                                                        <Input
                                                            type="file"
                                                            className="form-control"
                                                            id="profile_image"
                                                            accept="image/*"
                                                            onChange={handleImageChange}
                                                        />
                                                        {error.profile_image && (
                                                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.profile_image[0]}</FormFeedback>
                                                        )}
                                                        {errorimage && (
                                                            <FormFeedback type="invalid" style={{ display: 'block' }}>{errorimage}</FormFeedback>
                                                        )}
                                                    </div>
                                                ) : null}

                                                <div className="mb-3">
                                                    <Label className="form-label">Status</Label>
                                                    <div className="form-check form-switch form-switch-lg mb-3">
                                                        <Input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id="customSwitchsizelg"
                                                            name="status"
                                                            defaultChecked={status}
                                                            onChange={handleStatusChange}
                                                        />
                                                        <Label
                                                            className="form-check-label"
                                                            htmlFor="customSwitchsizelg"
                                                        >
                                                            {status ? 'Active' : 'Inactive'}
                                                        </Label>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="text-left mt-4">
                                                <Button type="submit" color="secondary">
                                                    Save {accountTitle}
                                                </Button>
                                            </div>
                                        </Form>
                                    </CardBody>
                                </Card>
                            }
                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment >
    );
};

export default UserAdd;
